import styled from 'styled-components';

export const MainWrapper = styled.main`
  grid-area: main;
  padding: 15px 30px;
  overflow-y: auto;
  background-color: var(--light);
`;

export const MainInfo = styled.div`
  font-size: 30px;
  color: var(--gray-1);
`;
